// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "TeamWriteDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { Role } from "./role.enum.gen";
import { TeamPlanType } from "./team-plan-type.enum.gen";
import { ThemeGenShape } from "./theme.gen";

export const TeamWriteDtoGenShape = z.strictObject({
  name: z.string(),
  logoImage: z.string(),
  fullName: z.string(),
  serviceName: z.string(),
  domain: z.string(),
  headerImage: z.string(),
  roles: z.array(z.enum(Role)),
  additionalLibraries: z.array(z.string()),
  planType: z.enum(TeamPlanType),
  expiry: z.string(),
  theme: ThemeGenShape,
  notificationsEnabled: z.boolean(),
});
